import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Banner from './components/Banner';
import Featured from './components/Featured';
import Latest from './components/Latest';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Categories />
      <Banner />
      <Featured />
      <Latest />
      <Newsletter />
      <Footer />
    </div>
  );
}

export default App;
